// @flow

import React                     from 'react';
import TabItems                  from './tabItems';

import './index.css';

const Tabs = ({ translate, categories, activeCategory, handleActiveCategory } :
  { translate: Function, categories: Array<Object>, activeCategory: Object, handleActiveCategory: Function }) => (
  <div className="special-deals js-special-deals">
    <header className="heading">
      <div className="holder">
        <h1>{translate('specialdeals.heading', null, { renderInnerHtml: true })}</h1>
      </div>
      <div className="ttl-bar">
      </div>
    </header>

    {categories &&
      <div className="deals-block js-deals">
        <div className="category">
          <TabItems
            categories={categories}
            handleActiveCategory={handleActiveCategory}
            activeCategory={activeCategory}
          />
        </div>
        <div className="button-row">
          <p className="note">
            <em>{translate('specialdeals.no_obligation')}</em>
          </p>
        </div>
      </div>
    }
  </div>
);

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/main/specialDeals/tabs.js